import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InViewportModule } from 'ng-in-viewport';
import { IonicModule } from '@ionic/angular';

import { DietmealPageRoutingModule } from './dietmeal-routing.module';

import { DietmealPage } from './dietmeal.page';
import { IonicRatingModule } from 'ionic4-rating';
// import { BrowserModule } from '@angular/platform-browser'


@NgModule({
  imports: [
  CommonModule,
    FormsModule,
    IonicModule,
    DietmealPageRoutingModule,
    IonicRatingModule,
    InViewportModule,
    // BrowserModule
  ],
  declarations: [DietmealPage],
  exports: [DietmealPage],
  
})
export class DietmealPageModule {}
